import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@primer/primitives/dist/css/primitives.css';
import '@primer/primitives/dist/css/functional/themes/dark.css';
import { AppProvider } from './state/AppContext';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { DialogProvider } from './components/AppDialog';
import { AppTheme } from './components/AppTheme';
import './fonts.css';
import './styles.css';
import './typography.css';
createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppTheme>
      <BrowserRouter>
        <ErrorBoundary>
          <AppProvider>
            <DialogProvider>
              <App />
            </DialogProvider>
          </AppProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </AppTheme>
  </React.StrictMode>,
);
